import { createFileRoute } from '@tanstack/react-router'
import { organizationUserSearchSchema } from '@/features/filter-organization-users/model/organizationUserSearch'
import { OrganizationUsersPage } from '@/pages/organization-users/ui/OrganizationUsersPage'

export const Route = createFileRoute('/user-management')({
  validateSearch: organizationUserSearchSchema,
  component: OrganizationUsersPage,
})
